<template>
    <div id="app" :class="{'is-edge': isEdge}">
        <the-header v-if="!isOtherWindow"></the-header>
        <main class="site-main" v-if="!isOtherWindow">
            <div class="site-main__inner" :class="{'direction-down': isDown}">
                <pageTitle></pageTitle>
                <modal></modal>
                <step-list></step-list>
                <div class="step-wrapper">
                    <transition name="slide" @before-leave="scrollTop" appear>
                        <router-view/>
                    </transition>
                </div>
                <p class="text-sign" v-show="isSignVisibled">ORIX 2018-A-066</p>
            </div>
        </main>
        <main v-else>
            <router-view/>
        </main>
        <the-footer v-if="!isOtherWindow"></the-footer>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import TheHeader from '@/components/Header.vue';
    import TheFooter from '@/components/Footer.vue';
    import PageTitle from '@/components/Title.vue';
    import Modal from '@/components/Modal';
    import StepList from '@/components/StepList.vue';
    import smoothScroll from './assets/js/SmoothScroll.js';
    import URI from 'urijs';

    export default {
        name: 'App',
        components: {
            TheHeader,
            TheFooter,
            PageTitle,
            Modal,
            StepList
        },
        data() {
            return {
                isDown: true,
                isEdge: false,
                isOtherWindow: false,
                isSignVisibled: false
            };
        },
        computed: {
            ...mapGetters([
                'agencyMode',
                'agencyCode',
                'agentCode'
            ])
        },
        methods: {
            ...mapActions([
                'changeAgencyCode',
                'changeAgentCode',
                'changeAgencyMode'
            ]),
            scrollTop() {
                smoothScroll.scroll(0, 500);
            },
            checkSlideDirection(to, from) {
                const fromName = from.name;
                const toName = to.name;
                let isDown = false;

                if (
                    (fromName === 'Step1' && toName === 'Step2') ||
                    (fromName === 'Step1' && toName === 'Step2Agency') ||
                    (fromName === 'Step2' && toName === 'Step3') ||
                    (fromName === 'Step2Agency' && toName === 'Step3') ||
                    (fromName === 'Step3' && toName === 'Step4')
                ) {
                    isDown = true;
                }

                this.$data.isDown = isDown;
            },
            checkSignVisibled() {
                const currentRoute = this.$router.currentRoute;

                if (currentRoute.name === 'Step4') {
                    this.$data.isSignVisibled = true;
                } else {
                    this.$data.isSignVisibled = false;
                }
            },
            checkUserAgent() {
                const userAgent = navigator.userAgent;
                let isEdge = false;

                if (0 <= userAgent.indexOf('Edge')) {
                    isEdge = true;
                }

                this.$data.isEdge = isEdge;
            },
            checkOtherWindow() {
                const currentRoute = this.$router.currentRoute;
                const name = currentRoute.name;
                let isOtherWindow = false;

                if (name === 'ImageViewNenkinTeikibin' || name === 'ImageViewNenkinHayamihyou') {
                    isOtherWindow = true;
                }

                this.$data.isOtherWindow = isOtherWindow;
            },
            sendTrackingCode() {
                const s = window.s;
                const STEPS = {Step1: 'STEP1', Step2: 'STEP2', Step2Agency: 'STEP2', Step3: 'STEP3', Step4: '結果'};

                if (s) {
                    // 流入時（直接遷移・リロード）
                    let agencyVariableString;
                    let sCode;
                    const stepName = this.$route.name ? STEPS[this.$route.name] : 'STEP1';

                    if (this.agencyMode) {
                        agencyVariableString = this.agencyCode + '|' + this.agentCode;
                    } else {
                        agencyVariableString = '|';
                    }

                    s.pageName = '【RWD】公的保障試算ツール(' + stepName + ')';
                    s.prop11 = agencyVariableString;
                    s.eVar11 = agencyVariableString;
                    s.events = 'event1';

                    sCode = s.t();

                    if (sCode) {
                        document.write(sCode);
                    }
                }
            }
        },
        watch: {
            '$route'(to, from) {
                this.checkSlideDirection(to, from);
                this.checkSignVisibled();
            }
        },
        created() {
            this.checkUserAgent();
            this.checkOtherWindow();
            this.checkSignVisibled();

            const uri = new URI(window.location.href);

            // 念のためノーマライズ
            uri.normalize();

            const query = uri.query(true);

            // ?teian=1がURLに含まれるとき（値は頭が1であれば何でもOK）
            if (query.hasOwnProperty('teian') && query.teian[0] === '1') {
                // （Step1もしくはステップなし） かつ未認証の場合のみ表示（他 Step では表示させない）
                if ((this.$route.name === 'Step1' || this.$route.name === null) && !this.agencyMode) {
                    // 「代理店コード」クエリとクエリ値があるなら、自動入力
                    uri.hasQuery('olinavi_ag', (value, name) => {
                        const defined = uri.hasQuery(name);
                        let result = false;

                        if (defined) {
                            this.changeAgencyCode(value);
                            result = true;
                        }

                        return result;
                    });

                    // 「募集人コード」クエリとクエリ値があるなら、自動入力
                    uri.hasQuery('olinavi_sl', (value, name) => {
                        const defined = uri.hasQuery(name);
                        let result = false;

                        if (defined) {
                            this.changeAgentCode(value);
                            result = true;
                        }

                        return result;
                    });

                    if (uri.hasQuery('olinavi_sl') && uri.hasQuery('olinavi_ag')) {
                        this.changeAgencyMode(true);
                    }
                }
            }

            // STEP1じゃないとき、もしくは代理店コードと募集人コードがそろっている場合はモーダルを表示せず、ページ読み込み時にトラッキングコードを送信する
            if (((uri.hasQuery('olinavi_sl') && uri.hasQuery('olinavi_ag')) || (this.agencyCode && this.agentCode)) || this.$route.name !== 'Step1') {
                this.sendTrackingCode();
            }

            // URL にステップ数がない場合、強制的に STEP1 へ置換
            if (this.$router.currentRoute.path === '/') {
                this.$router.replace('step1');
            }
        }
    };
</script>

<style>
    @import "assets/css/common.css";
</style>



// WEBPACK FOOTER //
// src/App.vue